import { Box, Grid, GridProps, MenuItem, TextField, TextFieldProps } from "@mui/material";
import { FC, useContext, useEffect, useMemo } from "react";
import ProjectsContext from "../../contexts/data/ProjectsContext";
import useStagesByProjectIds from "../../hooks/data/useStagesByProjectIds";

interface IStageMultiSelect extends Omit<TextFieldProps, 'variant' | 'onChange'> {
    GridProps?: GridProps,
    selectedProjectIds: number[],
    selectedStageIds: number[],
    onChange: (stageIds: number[]) => any,
}

const StageMultiSelect: FC<IStageMultiSelect> = ({
    selectedProjectIds,
    selectedStageIds,
    onChange,
    GridProps,
    slotProps,
    ...props
}) => {

    const {data: projects} = useContext(ProjectsContext);
    
    const {data: stages} = useStagesByProjectIds(selectedProjectIds);
    
    useEffect(() => {
        onChange(selectedStageIds.filter(x => stages?.map(stage => stage.id).includes(x)))
    }, [stages])
    

    const handleStagesChange = (event: any) => {
        onChange(event.target.value);
    }

    const nameMap = useMemo<Record<number, string>>(() => (
        stages?.reduce<Record<number, string>>((state, current) => {
            if(!current.id) {
                return state;
            }
            state[current.id] = `${projects?.filter(project => project.id == current.projectId)[0].name} - ${current.name}`;

            return state;
        }, {}) ?? {}
    ), [stages, projects]);

    return (
        <Grid
            size={{
                xs: 12
            }}
            {...GridProps}
        >
            {
                selectedProjectIds.length > 0 && 
                <TextField
                    select
                    fullWidth
                    label="Stages"
                    value={selectedStageIds}
                    slotProps={{
                        ...slotProps,
                        select: {
                            ...slotProps?.select,
                            multiple: true,
                            MenuProps: {
                                sx: {
                                    maxHeight: 500
                                }
                            },
                            renderValue: (selected) => (
                                <Box sx={{ display: 'flex', flexDirection: "column", flexWrap: 'wrap', gap: 0.5 }}>
                                    {
                                        (selected as number[]).map((value) => (
                                            <Box key={`stage-filter-${value}`}>{nameMap[value!]}</Box>
                                        ))
                                    }
                                </Box>
                            )
                        }
                    }}
                    onChange={handleStagesChange}
                    {...props}
                >
                    {
                        stages?.map(stage => 
                            <MenuItem key={stage.id} value={stage.id}>{nameMap[stage.id!]}</MenuItem>
                        )
                    }
                </TextField>
            }
        </Grid>
    );
}

export default StageMultiSelect;